import { render } from "./LabCreate3EditPropack.vue?vue&type=template&id=94b83a8a"
import script from "./LabCreate3EditPropack.vue?vue&type=script&lang=js"
export * from "./LabCreate3EditPropack.vue?vue&type=script&lang=js"

import exportComponent from "C:\\xampp\\htdocs\\mlab\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__